import apiClient from './apiClient';

const notificationService = {
  /**
   * Get unread notifications
   */
  getUnread: async () => {
    const response = await apiClient.get('/notifications/unread');
    return response.data;
  },

  /**
   * Get all notifications with pagination
   */
  getAll: async (page = 1, limit = 20) => {
    const response = await apiClient.get('/notifications', {
      params: { page, limit },
    });
    return response.data;
  },

  /**
   * Get unread count
   */
  getUnreadCount: async () => {
    const response = await apiClient.get('/notifications/count');
    return response.data;
  },

  /**
   * Mark notification as read
   */
  markAsRead: async (id) => {
    const response = await apiClient.patch(`/notifications/${id}/read`);
    return response.data;
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async () => {
    const response = await apiClient.patch('/notifications/read-all');
    return response.data;
  },
};

export default notificationService;
